import React, { useState } from "react";

//package import

import {
  Box,
  Paper,
  TextField,
  Grid,
  Typography,
  useTheme,
  Button,
  CircularProgress,
  Snackbar,
  Backdrop,
  Alert,
} from "@mui/material";
import { NoteAlt as NoteAltIcon } from "@mui/icons-material";
import { formControlClasses } from "@mui/material/FormControl";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { Formik, Form } from "formik";
import { useNavigate, useSearchParams } from "react-router-dom";

//user import

import { headersPost } from "../../Services/API";
import { API_URLS } from "../../Services/Routes/API";
import { RoutesUrls } from "../../Services/Routes/APP";
import { newPasswordSchema } from "../../Services/validations/SetPassword";
import { Logo } from "../../Svg";

//constants

const initialValues = {
  password: "",
  con_password: "",
};

//component

const SetPassword = () => {
  //hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");

  //states

  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");

  //form submit handler

  const formSubmitHandler = (values) => {
    if (token) {
      const data = {
        user: {
          token: token,
          password: values?.password,
        },
      };
      setOpen(true);

      headersPost(API_URLS?.RESET_PASSWORD, data)
        .then((res) => {
          if (res?.status === 200 && res?.data?.success) {
            setAlertOpen(true);
            setAlertMsg(res?.data?.message);
            setAlertIcon("success");
            setTimeout(() => {
              navigate(RoutesUrls?.root);
            }, 100);
          } else {
            setOpen(false);
            setAlertOpen(true);
            setAlertMsg(res?.data?.message);
            setAlertIcon("warning");
          }
        })
        .catch((err) => {
          const { response } = err;
          setOpen(false);
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        });
    } else {
      setAlertOpen(true);
      setAlertMsg(
        "Your Url is invalid. Please try again or contact with admin"
      );
      setAlertIcon("error");
    }
  };

  // close snackbar

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setAlertOpen(false);
  };

  //render

  return (
    <Box bgcolor={theme.palette.info}>
      <Grid container height={"100vh"} padding={2}>
        <Grid
          item
          sx={{ display: { xs: "none", sm: "block" } }}
          xs={12}
          sm={6}
          md={6}
          alignContent={"center"}
        >
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            flexDirection={"column"}
            height={"100%"}
            width={"100%"}
          >
            <Typography
              variant="h3"
              color={theme.palette.background}
              sx={{ fontWeight: 700 }}
            >
              Create New
            </Typography>
            <Typography
              variant="h3"
              color={theme.palette.background}
              sx={{ fontWeight: 700 }}
            >
              Password
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"100%"}
            width={"100%"}
          >
            <Paper
              sx={{
                padding: { xs: 2, sm: 3, md: 4 },
                borderRadius: theme.spacing(1),
              }}
            >
              <Box display={"flex"} justifyContent={"center"} pt={2}>
                <Box
                  borderRadius={"100%"}
                  width={110}
                  height={110}
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Box>
                    <Logo
                      sx={{
                        width: 90,
                        height: 90,
                      }}
                    />
                  </Box>
                </Box>{" "}
              </Box>

              <Formik
                onSubmit={formSubmitHandler}
                initialValues={initialValues}
                validationSchema={newPasswordSchema}
              >
                {({ values, touched, handleChange, handleSubmit, errors }) => (
                  <Form onSubmit={handleSubmit}>
                    <Box pt={2} sx={{ display: { xs: "block", sm: "none" } }}>
                      <Typography
                        display={"flex"}
                        justifyContent={"center"}
                        fontWeight={"bold"}
                        variant="h6"
                      >
                        Create New Password
                      </Typography>
                    </Box>
                    <Box py={{ xs: 2, sm: 3 }}>
                      <Typography
                        display={"flex"}
                        justifyContent={"center"}
                        fontWeight={"bold"}
                        variant="body1"
                      >
                        RL Node Planner
                      </Typography>
                    </Box>
                    <Box padding={1}>
                      <TextField
                        fullWidth
                        name="password"
                        type={"password"}
                        placeholder="Please enter your password"
                        variant="outlined"
                        value={values?.password}
                        error={touched?.password && Boolean(errors?.password)}
                        helperText={touched?.password && errors?.password}
                        onChange={handleChange}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      ></TextField>
                    </Box>

                    <Box padding={1}>
                      <TextField
                        fullWidth
                        name="con_password"
                        type={"password"}
                        placeholder="Please confirm your password"
                        variant="outlined"
                        value={values?.con_password}
                        error={
                          touched?.con_password && Boolean(errors?.con_password)
                        }
                        helperText={
                          touched?.con_password && errors?.con_password
                        }
                        onChange={handleChange}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      ></TextField>
                    </Box>
                    <Box
                      padding={1}
                      display={"flex"}
                      justifyContent={"center"}
                      py={2}
                    >
                      <Box width={"50%"}>
                        <Button
                          variant="contained"
                          type="submit"
                          fullWidth
                          sx={{
                            borderRadius: theme.spacing(1),
                          }}
                        >
                          Create
                        </Button>
                      </Box>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Paper>
          </Box>
        </Grid>
        {/* <Grid item xs={false} sm={false} md={1}></Grid> */}
      </Grid>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default SetPassword;
